import {css} from "@emotion/react";
import React from 'react';
import {Grid} from "../../../Grid";
import {Card} from "../../../TabsRoute/components/Card";
import {column, numberOfCallsText, row, textTotal, textTotalNumber, total, topFive, textTopFive,tFHead,tFHeadText,tFRow,tFMineText,tFDisclaimer,tFMineTextLink} from "../../styles";
import {TSMMonitoringContext} from "../../../TSMMonitoring/components/TSMMonitoringProvider";
import {DustFreeSvg} from "../DustFreeSvg";
import {useHDMinesByPeriod} from "../../../../sdk/queries";


export const MineList = ({location_id, period_s}:
			 {location_id: number, period_s: string}) =>
    {
	//const {callLogs} = React.useContext(TSMMonitoringContext);

	const hd_mines = useHDMinesByPeriod({
	    variables: {
		id: String(location_id),
		period_date: period_s,
		limit: String(5),
	    }
	});

	const top_mines = (hd_mines?.data?.data || []);

	console.log('top_mines: ' + top_mines);

	const top_mine_list = [1,2,3,4,5]

	return (
	    <Card padding={"0 40px"} contentCss={css({backgroundColor: "#F7FBFF"})}>
		<div css={column}>
		<div css={row}>
		<div css={topFive}>
		<p css={textTopFive}>Top 5 Mines Associated with High Dust Alerts*</p>
		</div>
		</div>
		<div css={row}>
		<div css={tFHead}>
		<p css={tFHeadText}>Mine</p><p css={tFHeadText}>Mine Code</p><p css={tFHeadText}>Association Frequency</p><p css={tFHeadText}>All Trains for Mine</p>
		</div>
		</div>
		{top_mine_list.map((num,index) =>
		    {
			return(
			    <div css={tFRow}>
				<p css={tFMineText}>{top_mines[index]?.name || '?'}</p>
				<p css={tFMineText}>{top_mines[index]?.mine_cd || '?'}</p>
				<p css={tFMineText}>{String(top_mines[index]?.frequency) || '?'}</p>
				<p css={tFMineText}>{String(top_mines[index]?.total) || '?'}</p>
			    </div>
			)
			
		    })
		} 	    
		
		<div css={tFRow}>
		<p css={tFDisclaimer}>* Trains exceeding alert category during the selected month.</p>
		</div>
		</div>
		</Card>

	);
    };
